import { I18N_DEFAULT_LANGUAGE } from 'common/utils/helpers/i18next';

export const HEADER_NAVIGATION_LINKS = [
  {
    label: 'policyOverview',
    path: '/dashboard',
    matcher: /dashboard/,
  },
  {
    label: 'policies',
    path: '/policies',
    matcher: /policies/,
  },
  {
    label: 'quotes',
    path: '/quotes',
    matcher: /quotes/,
  },
  {
    label: 'claims',
    path: '/claims',
    matcher: /claims/,
  },
  {
    label: 'billing',
    path: '/billing',
    matcher: /billing/,
  },
  {
    label: 'partyDocuments',
    path: '/party-documents',
    matcher: /party-documents/,
  },
];

export const languagePath = '/images/language-icons/';

export const defaultLanguage = {
  language: I18N_DEFAULT_LANGUAGE,
  languageDisplay: 'English',
  imagePath: `${languagePath}eng.png`,
};

export const languages = [
  {
    language: 'en',
    languageDisplay: 'English',
    imagePath: `${languagePath}eng.png`,
    selected: true,
    disabled: true,
  },
  {
    language: 'dan',
    languageDisplay: 'Danish',
    imagePath: `${languagePath}dan.png`,
    selected: false,
    disabled: true,
  },
  {
    language: 'span',
    languageDisplay: 'Spanish',
    imagePath: `${languagePath}span.png`,
    selected: false,
    disabled: true,
  },
];
